<template>
  <NuxtLayout>
    <NuxtPage/>
  </NuxtLayout>
</template>

<script setup lang="ts">
const route = useRoute();
const siteConfig = useSiteConfig();

// One canonical URL per page: production host, path only (query dropped).
// A page reachable under several paths (route aliases) names its main one in
// `definePageMeta({ canonicalPath })`.
const canonicalPath = computed(() =>
  typeof route.meta.canonicalPath === 'string' ? route.meta.canonicalPath : route.path);

useHead({
  link: [
    { rel: 'canonical', href: computed(() => `${ siteConfig.url }${ canonicalPath.value }`) },
  ],
});
</script>
